export default __webpack_public_path__ + "static/media/1762.180214b2.png";